module.exports = __webpack_public_path__ + "static/img/ureter-3.cf6b681.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/ureterpic/ureter-3.jpg
// module id = lAFw
// module chunks = 52